import { createAction, props } from "@ngrx/store";
import { IExecuteSeccess, IImport, IImportFilter, IImportFilterRequest, IMatchingColumn, IMatchingErrorsResponse, IResponseMatching, IRowsErrorsResponse } from "../models/imports.models";
import { IPageCount } from "src/app/shared/models/page.model";
import { APIResponse } from "src/app/core/models/api-response";

// get imports
export const GetImports = createAction(
  '[ import ] - GetImports',
  props<{ page: IPageCount, filter?: IImportFilterRequest | undefined, key?: string | undefined }>()
);
export const GetImportsSuccess = createAction(
  '[ import ] - GetImports Success ',
  props<{ imports: APIResponse<IImport> }>()
);
export const GetImportsError = createAction(
  '[ import ] - GetImports Error',
);


// set file
  export const ImportProducts = createAction(
    '[ import ] - ImportProducts',
    props<{ file: any, reimport: boolean }>()
  );
  export const ImportProductsSuccess = createAction(
    '[ import ] - ImportProducts Success ',
    props<{ responseMatching: IResponseMatching, reimport: boolean }>()
  );
  export const ImportProductsError = createAction(
    '[ import ] - ImportProducts Error',
  );

  // reset file
  export const ReImportProducts = createAction(
    '[ import ] - ReImportProducts',
    props<{ id: number, file: any }>()
  );
  export const ReImportProductsSuccess = createAction(
    '[ import ] - ReImportProducts Success ',
    props<{ responseMatching: IResponseMatching }>()
  );
  export const ReImportProductsError = createAction(
    '[ import ] - ReImportProducts Error',
  );

  // matching columns
  export const MatchingColumns = createAction(
    '[ import ] - MatchingColumns',
    props<{ id: number, matchingColumns: IMatchingColumn, committed?: boolean }>()
  );
  export const MatchingColumnsSuccess = createAction(
    '[ import ] - MatchingColumns Success ',
    props<{ executeSeccess: IExecuteSeccess, test: boolean }>()
  );
  export const MatchingColumnsError = createAction(
    '[ import ] - MatchingColumns Error',
    props<{ responseMatching: IMatchingErrorsResponse | IRowsErrorsResponse }>()
  );


  // set file
  export const DetailsImport = createAction(
    '[ import ] - DetailsImport',
    props<{ id: number }>()
  );
  export const DetailsImportSuccess = createAction(
    '[ import ] - DetailsImport Success ',
    props<{ deatailsImport: IExecuteSeccess }>()

  );
  export const DetailsImportError = createAction(
    '[ import ] - DetailsImport Error',
  );

  // clear details
  export const ClearDetailsImport = createAction(
    '[ import ] - ClearDetailsImport',
  );

  //loader actions
  export const SetImportLoader = createAction(
    '[ Import ] - SetLoading',
    props<{ isLoading: boolean }>()
  );

  export const SetExecuteImportLoader = createAction(
    '[ Import ] - SetLoading',
    props<{ isLoading: boolean }>()
  );

  // search
  export const SetImportSearch = createAction(
    '[ Import ] - SetImportSearch',
    props<{ search: string }>()
  );

  // filter
  export const SetImportFilter = createAction(
    '[ Import ] - SetImportFilter',
    props<{ keyword: string, advanced: IImportFilter | null }>()
  );
